import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { Checkbox, Separator, Button, Row, Col, Label, FormGroup, Input as InputPure, InputGroup, InputGroupText, DefaultPopover } from 'twyne-new.ui'

import Select from 'components/form/Select';

export default function Form({ index, data, name, options, onAdd, onChange, onRemove, toggle, setToggle }) {
  const [id, setId] = useState('')
  const [override, setOverride] = useState(false)
  const [versions, setVersions] = useState([])
  const [postVersions, setPostVersions] = useState([])
  const [postVersionId, setPostVersionId] = useState(null)
  const [weight, setWeight] = useState(1)

  const { id: _id } = data || {}
  const disabled = !id || (override && postVersionId === null)

  useEffect(() => {
    if (_id && toggle) {
      data.post_version_id = (data.override_post_version && data.post_version_id == null) ? '' : data.post_version_id

      setId(_id)
      setOverride(data.override_post_version)
      setPostVersionId(data.post_version_id)
      setWeight(data.weight)
    }
  }, [_id, toggle, data])

  useEffect(() => {
    if (!override) setPostVersionId(null)
  }, [override])

  useEffect(() => {
    if (id && options && options.length) {
      const { versions } = options.find(p => p.value === id) || {}
      if (versions) {
        setPostVersions(versions)
      }
    }
  }, [id, options])

  useEffect(() => {
    if (override) {
      setVersions([{ label: 'default', value: '' }, ...postVersions])
    }
  }, [postVersions, override])

  const handleApply = () => {
    const offer = {
      id,
      weight,
      override_post_version: override,
      post_version_id: postVersionId == '' ? null : postVersionId,
    }

    onChange ? onChange(index, offer) : onAdd(offer)
    handleClose()
  }

  const handleRemove = () => {
    onRemove(index)
    handleClose()
  }

  const handleClose = () => {
    setToggle(false)
    setId('')
    setOverride(false)
    setPostVersionId(null)
    setWeight(1)
  }

  const handleChangeOffer = option => {
    const { value: id } = option
    setId(id)
  }

  return <DefaultPopover
    trigger={<span></span>}
    wrapperProps={{ open: toggle, onOpenChange: handleClose }}
  >
    {_id ? <>
      Edit <Link to={`/offer/offers/${_id}`} target='_blank'>
        [#{_id}] {name}
      </Link>
    </> : 'Add Offer'}
    <Separator className='my-2' />
    <Row>
      <Col size="12">
        <FormGroup>
          <Label>Offer</Label>
          <Select
            name="_"
            value={id}
            options={options}
            handleOnChange={handleChangeOffer}
            clearable={false}
          />
        </FormGroup>
      </Col>

      <Col size="12">
        <FormGroup>
          <Label>Override Lander Version</Label>
          <InputGroup className="w-auto">
            <InputGroupText addonType='append'>
              <Checkbox
                onChange={checked => setOverride(checked)}
                value={override}
              />
            </InputGroupText>
            <Select
              name="_"
              value={postVersionId}
              options={versions}
              clearable={false}
              handleOnChange={option => setPostVersionId(option.value)}
              disabled={!override}
            />
          </InputGroup>
        </FormGroup>
      </Col>

      <Col size="12">
        <FormGroup>
          <Label>Weight</Label>
          <InputPure
            type="number"
            value={weight}
            onChange={event => setWeight(parseInt(event.target.value))}
            min={1}
          />
        </FormGroup>
      </Col>

      <Col size="12" className='flex gap-2'>
        <Button block color="accent" size="sm" onClick={handleApply} disabled={disabled}>
          Apply
        </Button>
        {onRemove ? <Button color="danger" size="sm" variant='ghost' onClick={handleRemove} block>
          Remove
        </Button> : null}
      </Col>

    </Row>

  </DefaultPopover>
}
